import { Fragment, useState } from 'react'
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form'

import { IconName } from 'ui/components'
import { IconButton } from 'ui/components/Buttons'
import { useConfirmation } from 'ui/hooks'
import { FormRow } from 'ui/themes/globalStyles'
import { SarEdit } from '~bank-bsa-reporting/types'

import { BankAccount } from './fields'

import { s } from './styles'

export const BankAccounts = ({ index1, index2 }: { index1: number; index2: number }) => {
  const { control } = useFormContext<SarEdit>()
  const [itemToRemove, setItemToRemove] = useState<number | null>(null)

  const { fields, append, remove } = useFieldArray({
    control,
    name: `subjectsInfo.${index1 as 0}.institutionsInfo.${index2 as 0}.accountNumbers`
  })

  const noKnownAccountsInvolved = useWatch({ control, name: `subjectsInfo.${index1 as 0}.noKnownAccountsInvolved` })

  const { open: startDeleting, Confirmation } = useConfirmation({
    message: `Are you sure you want to remove this item?`,
    onConfirm: () => itemToRemove !== null && remove(itemToRemove),
    confirmationButtonText: 'Delete',
    isConfirmationNegative: true
  })

  return (
    <s.BankAccountsContainer>
      <Confirmation />
      {fields.map((field, index3) => (
        <Fragment key={field.id}>
          <BankAccount index1={index1} index2={index2} index3={index3} />
          <FormRow>
            {fields.length > 1 && (
              <IconButton
                face="negative"
                icon={IconName.DELETE}
                onClick={() => {
                  setItemToRemove(index3)
                  startDeleting()
                }}
              />
            )}
          </FormRow>
        </Fragment>
      ))}
      {!noKnownAccountsInvolved && (
        <s.BankAccountsButton>
          <IconButton
            icon={IconName.ADD_GREEN}
            onClick={() =>
              append({
                number: '',
                closed: false,
                formattedNumber: ''
              })
            }
          />
        </s.BankAccountsButton>
      )}
    </s.BankAccountsContainer>
  )
}
